<div>
    <div class="flex items-center justify-center h-[70px]">
        <h4 class="xl:text-xl lg:text-lg text-primary text-lg font-medium font-sans font-medium">
            Download WO Photos
        </h4>
    </div>
    <mat-dialog-content class="!pt-0">
        <form [formGroup]="downloadWoForm" class="!mt-1">
            <div class="mb-4">
                <mat-checkbox formControlName="includeLinkedWo" color="primary">Include linked WO</mat-checkbox>
            </div>
            <!-- Hidden on request: "Include media" is commented out rather than removed.
                 The control stays in the form defaulted to false, so media is not part of
                 the download unless this option is put back and ticked.
            <div class="mb-4">
                <mat-checkbox formControlName="includeMedia" color="primary">Include media</mat-checkbox>
            </div>
            -->
            <mat-dialog-actions class="!p-0 flex !justify-center !mb-3">
                <button mat-flat-button mat-dialog-close color="accent" class="text-primary secondary-button">Cancel</button>
                <button mat-flat-button color="primary" (click)="onDownloadPhotos()" class="text-primary primary-button">Download Wo Photos</button>
            </mat-dialog-actions>
        </form>
    </mat-dialog-content>
</div>
